var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('home-events',{staticClass:"mb-8"}),_c('home-transactions',{staticClass:"mb-8"}),_c('home-members')],1)}
var staticRenderFns = []

export { render, staticRenderFns }